export default "__VITE_ASSET__D_6Iu6Io__"